import { createBreakpoint } from "react-use";

const breakpoints = {
  lg: 1024,
  md: 768,
  sm: 640,
  xl: 1280,
};

const useBreakpoint = createBreakpoint(breakpoints);

/**
 * @deprecated it causes SSR dehydrate mismatch
 * Replace with tailwind breakpoint classnames
 */
export const useBreakpoints = () => {
  const currentBreakpoint = useBreakpoint();

  return {
    currentBreakpoint,
    breakpoints: breakpoints,
  };
};
